import { C } from "../data/content";

export const Letter = () => (
  <section className="py-28 px-6" style={{ background: "rgba(255,255,255,0.015)" }} data-testid="letter-section">
    <div className="max-w-[760px] mx-auto">
      <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-8">[002] — A LETTER FROM DARREN</p>
      <p className="text-lg text-white/60 italic mb-8">Fellow Veteran,</p>
      <p className="text-[15px] text-white/55 leading-[1.8] mb-8">
        If you've started looking at homes, you've probably run into at least one of these three ideas. I hear them every week — and every one of them keeps good buyers on the sidelines:
      </p>
      <div className="space-y-4 mb-10">
        {C.falseBeliefs.map((b, i) => (
          <div key={i} className="belief-card p-5 flex gap-4 items-start" data-testid={`false-belief-${i + 1}`}>
            <span className="text-red-400 font-black text-lg leading-none">✗</span>
            <p className="text-[14px] text-white/70 italic">{b}</p>
          </div>
        ))}
      </div>
      <div className="h-px w-24 mb-10" style={{ background: "var(--accent)" }} />
      <div className="space-y-6 text-[15px] text-white/55 leading-[1.8]">
        <p>
          Here's what I've learned working inside this process: your VA entitlement is a benefit you earned, and for eligible buyers it can mean purchasing with no down payment at all — that's how the program is designed, not a loophole.
        </p>
        <p>
          Credit is rarely the wall people assume it is. VA guidelines look at your whole picture — income, residual income, history — not just a single score. Many buyers I speak with are far closer than they were told, and some who were told "not yet" simply never had anyone actually review their real numbers.
        </p>
        <p>
          And applying to a handful of lenders before you know your own position? That's backwards. It invites hard credit pulls, generic quotes, and pressure — before you even know what you qualify for. Know your real number first. Then decide, on your timeline, with no obligation to me or anyone else.
        </p>
      </div>
      <p className="mt-10 font-bold text-[var(--accent)]">— {C.hostName}, {C.hostCompany}</p>
    </div>
  </section>
);
